module.exports = __webpack_public_path__ + "img/testimonial-katja-zmitek.f5806875.png";